import store from '../store';
import {
  getUrlParams,
  setQueryUrl,
  getModel,
  getSys,
  getScreen,
  getSign,
  getPhpNow,
  getUUids,
  getSignStatis,
  getTopDomain
} from '@/utils';
import { roleReportApi, lnsdkLoginApi, fushionLoginApi } from '@/api/statis';
import { getIpv6Api } from '@/api/nosdk';
import mixServer from './mixServer';
import { mixServerConfig } from '@/config';
import channelServer from './channelServer';
import { Dialog } from 'vant';
import pay from './pay';
import cookies from '@/cookies';
import { platform } from '@/check';
import statis from './statis';
import statisNew from './statis_new';
import { notificationPostmessager } from '../features/notificationPostmessager';
import { notificationAcceptMessager } from '../features/notificationAcceptMessager';
import { baseURL as mixServerBaseUrl } from '@/api/mixServer';

const isDev = process.env.NODE_ENV === 'development';
const server = {
  ver: getUrlParams('campaign_id'), // 修改ver取得内容为campaign_id，验签为verCheck
  verCheck: getUrlParams('ver'),
  appid: getUrlParams('appid'),
  campaign_id: getUrlParams('campaign_id'),
  idfa: getUrlParams('idfa') || '',
  idfv: getUrlParams('idfv') || 'idfv',
  imei: getUrlParams('imei') || 'imei',
  oaid: getUrlParams('oaid') || '',
  adver: getUrlParams('ver') || '',
  model: getUrlParams('model') || getModel(),
  android_id: getUrlParams('android_id') || '',
  // 微信支付参数
  code: getUrlParams('code'),
  shareParams: {},
  // 在线上报需要的参数
  onlineParams: {},
  expire_time: '',
  // 计时器
  timer: null,
  // 需要提前获取游戏链接
  mixConfigPromise: null,
  // 1s内角色上报数组
  roleArray: [],
  roleLevelTimer: null,
  roleActionLevel: '',
  timerOrderStatus: null,
  timesOrderStatus: 0,
  timerNewUser: null,
  isCreateRoleEvent: false,
  roleInfoData: {},
  // 2021.12.9 个人信息法 游戏使用声明弹窗 同意后才能进入游戏（init）
  gameReady() {
    let currentAgree = localStorage.getItem('ln_agree');
    if ((currentAgree == 1 || !currentAgree) && !localStorage.getItem('ln_status')) {
      // 异步队列
      setTimeout(() => {
        store.commit('SHOW', {
          name: 'GameState',
          params: { isVer: false }
        });
      }, 300);
    } else {
      // 每次进入游戏都需要判断是否显示前置红包(已启用)
      // 根据配置接口判断是否需要展示健康公告（放在融合配置接口内）
      // if (getUrlParams('appid') != '70652' && getUrlParams('appid') != '70660') {
      //   mixServer.getConfig().then(data => {
      //     store.commit('SET_OPEN_HEALTH', data.data.is_open_health);
      //     mixServer.init().then(data_init => {
      //       mixServer.getPreRebate({ access_token: data_init.data.access_token }).then(data_rb => {
      //         if (data_rb.url) {
      //           store.commit('SET_PRERB', true);
      //           store.commit('SET_PRERBURL', data_rb.url);
      //         } else {
      //           if (data.data.is_open_health == 1) {
      //             store.commit('SET_HEALTH', true);
      //             store.commit('SET_GAMEDIST', data.data.direction);
      //             setTimeout(() => {
      //               store.commit('SET_HEALTH', false);
      //               this.init();
      //             }, 2000);
      //           } else {
      //             this.init();
      //           }
      //         }
      //       });
      //     });
      //   });
      // } else {
        this.init();
      // }
    }
    this.setShareParams();
    // 启动上报
    statisNew.appActivate();
  },
  init() {
    const isContinue = this.wxHandle();
    // console.log(isContinue)
    if (!isContinue) return;
    if (isDev) setQueryUrl();
    const isUrlPass = this.checkUrl();
    if (!isUrlPass) {
      document.body.innerHTML = '验签错误，请联系管理员';
      return;
    }
    this.removePayPreloadTrasition();
    this.acceptMessage();
    // 接受通知中心传递过来的信息
    notificationAcceptMessager.acceptNoticationMessage();
    this.setShareParams();
    // 发送idfa到 sdk
    if (getUrlParams('idfa')) {
      // sendUrlParams(getUrlParams('idfa'))
    }

    this.getMixConfigPromise().then(() => {
      this.setGameFrame();
    });

    // 接口不在这里初始化，在收到登录信息时初始化
    // this.apiInit();
    // 测试在线时长（根据接口返回走防沉迷逻辑）
    // let testParams = { sign: '841ba05e7a9d6c0d9ef804ce682cd358', time: '1599804246994', access_token: '241c0bed8a3f5796bf4b8222b0cb89551e9528bae43302c93ede01856fb578929f896af23ecd17245e454bf54c399d49c23b02343a2bb711', ver: 'd821f19cbb', roleid: '298900778', server_id: '4200049' }
    // this.online(testParams);

    // 统计sdk补报
    if (localStorage.getItem('statis_ln_fulogin')) {
      fushionLoginApi(localStorage.getItem('statis_ln_fulogin'), 'fusion_login').then(data => {
        console.log(data);
        localStorage.removeItem('statis_ln_fulogin');
      });
    }
    if (localStorage.getItem('statis_ln_login')) {
      lnsdkLoginApi(localStorage.getItem('statis_ln_login'), 'lnsdk_login').then(data => {
        console.log(data);
        localStorage.removeItem('statis_ln_login');
      });
    }
    if (localStorage.getItem('statis_ln_role')) {
      roleReportApi(localStorage.getItem(), localStorage.getItem('statis_ln_role_ev')).then(data => {
        console.log(data);
        localStorage.removeItem('statis_ln_role');
        localStorage.removeItem('statis_ln_role_ev');
      });
    }
    const reportParams = {reporter: 3, ln_uid: 0, fu_uid: 0, role_id: '', role_name: '', server_id: '', server_name: '', event_data: JSON.stringify([{event: 'init_sdk_succ', event_properties: '', client_time: getPhpNow()}])}
    statisNew.appEventReport(reportParams)
    if (this.timerOrderStatus) clearTimeout(this.timerOrderStatus)
  },
  setGameFrame() {
    const url = mixServer.game_link;
    let gameFrame = document.querySelector('#gameFrame');
    gameFrame.src = `${url}`;
    // 设置通知中心链接
    try {
      let notyFrame = document.querySelector('#notification-frame');
      notyFrame.src = this.getTopDomain('ucash') + '/ucashfront/notification/index.html';
    } catch (error) {
      console.log(error)
    }
  },
  getTopDomain(secondDomain) {
    try {
      var host = window.location.host;
      var url ='https://' + host;;
      var domain = url.replace(/^https?:\/\//, '').split('/')[0];
      var domainParts = domain.split('.');
      var baseDomain = domainParts.slice(domainParts.length - 2).join('.');
      if (baseDomain.indexOf('lnqwe') > -1) {
        baseDomain = 'leniugame.com' 
      }
      var newDomain = 'https://' + secondDomain  + '.' + baseDomain;
      return newDomain 
    } catch (error) {
      return 'https://' + secondDomain  + '.' + 'leteng5.cn';
    }
  },
  getMixConfigPromise() {
    if (this.mixConfigPromise) {
      return this.mixConfigPromise;
    } else {
      return (this.mixConfigPromise = mixServer.getConfig());
    }
  },
  apiInit() {
    return new Promise((resolve, reject) => {
      if (this.hasInit) {
        resolve();
        return;
      }
      // 融合配置+初始化
      this.getMixConfigPromise().then(() => {
        mixServer.init().then(res => {
          // 配置+初始化
          // console.log(res);
          channelServer.getConfig().then(() => {
            channelServer.init().then(() => {
              this.hasInit = true;
              store.commit('SET_LOADING', false);
              resolve();
            });
            // 初始化的同时请求IPv6接口
            this.getIpV6();
          });
        });
      });
    });
  },
  checkUrl() {
    const params = {
      appid: this.appid,
      campaign_id: this.campaign_id,
      ver: this.verCheck
    };
    const sign = getSign('', params);
    const urlSign = getUrlParams('sign');
    // console.log(sign)
    // console.log(urlSign)
    const isPass = sign === urlSign;
    return isPass;
  },
  // 微信浏览器特殊处理
  wxHandle() {
    if (platform.isWeiXin) {
      if (!this.code) {
        const params = {
          redirect_uri: encodeURIComponent(location.href),
          time: getPhpNow(),
          fu_appid: getUrlParams('appid'),
          game_id: getUrlParams('game_id')
        };
        channelServer.getWxPayUrl(params).then(({ data = {} }) => {
          const { url } = data;
          location.href = url;
        });
        return false;
      }
    }
    return true;
  },
  // 去除一开始的支付页面动画
  removePayPreloadTrasition() {
    window.onload = () => {
      document.querySelector('.preload').classList.remove('preload');
    };
  },
  // 接受游戏窗口传递的信息
  acceptMessage() {
    window.addEventListener('message', e => {
      const payload = typeof e.data === 'string' ? { action: e.data } : e.data || {};
      const { action, params } = payload;
      const token = this.getToken();
      // 统计sdk上报参数
      let statisParams = {};
      if (action == 'TASK' || action == 'NIRVA') {
        statisParams = {
          role_id: params.roleId,
          role_name: params.roleName,
          server_id: params.serverId,
          server_name: params.serverName,
          level: params.roleLevel,
          power: params.power || 0,
          ln_uid: channelServer.ln_uid,
          fu_uid: mixServer.fu_uid,
          ouid: mixServer.ouid
        };
      }
      console.log(token);
      let reportParamsNew = {reporter: 1, ln_uid: parseInt(channelServer.ln_uid) || 0, fu_uid: parseInt(mixServer.fu_uid) || 0, 
        role_id: params?.roleId || '', role_name: params?.roleName || '', server_id: params?.serverId || '', server_name: params?.serverName || ''}
      let reportParams = {};
      if (action) {
        reportParams = { ln_uid: parseInt(channelServer.ln_uid), fu_uid: parseInt(mixServer.fu_uid) };
      }
      switch (action) {
        // 弹出登录框
        case 'LOGIN':
          this.apiInit().then(() => {
            if (token) {
              // 有token，自动登录
              const NO_AUTO_LOGIN_URL_CONFIG = [
                'https://sdk.sh9130.com',
                'https://h5.uu89.com',
                'luckystar001',
                'huanyuantech.com',
                'h5game.jiuyaowangluo.com',
                'isp2-dev.hhycdk.com',
                'https://isp2.hhycdk.com',
                'h5game.rastargame.com',
                'shdl-web-cdn.leniu.com',
                'shdl-web-test-cdn.leniu.com',
                'cls-wd03.youyantech.com'
              ];
              const IS_NO_AUTO_LOGIN = NO_AUTO_LOGIN_URL_CONFIG.some(v => mixServer.game_link.indexOf(v) > -1);
              if (!store.state.changeAccClick) {
                this.autoLogin();
              } else {
                this.showModal();
              }
            } else {
              // 没有token，不需自动登录，拉起登录窗口
              this.showModal();
            }
          });
          break;
        case 'LOGOUT':
          this.cpChangeAccount();
          break;
        // 下单，拉起支付
        case 'PAY':
          console.log('pays事件');
          this.handlePay(params);
          break;
        // 支付页面传递过来的，关闭支付页面
        case 'PAY_CLOSE':
          pay.close();
          break;
        // 支付页面传递过来的，在微信浏览器调起支付
        case 'PAY_WEIXIN':
          pay.weixin(params);
          break;
        case 'ROLE_REPORT':
          this.handleRoleReport(params);
          break;
        // sdk红包页面发送消息
        case 'REDACC':
          this.openAccount(params);
          break;
        case 'REDACCSET':
          this.setAccount(params);
          break;
        case 'KEFU':
          this.openKefu(params);
          break;
        // 2023.4统计sdk
        case 'ZONE':
          statis.getZoneId(params);
          break;
        case 'TASK':
          statis.mainTask([{ ...statisParams, main_task: params.main_task || '' }]);
          statisNew.appEventReport({...reportParamsNew, event_data: JSON.stringify([{event: 'main_task', event_properties: {}, client_time: getPhpNow() }])})
          break;
        case 'NIRVA':
          statis.nirvana([{ ...statisParams, nirvana: params.nirvana || '' }]);
          statisNew.appEventReport({...reportParamsNew, event_data: JSON.stringify([{event: 'nirvana', event_properties: {}, client_time: getPhpNow() }])})
          break;
        case 'CPAGE':
          statis.createPage([reportParams]);
          break;
        case 'INIT':
          statis.initialize([]);
          break;
        case 'SELSERVER':
          statis.selectServer([reportParams]);
          break;
        case 'FINSERVER':
          statis.finishServer([reportParams]);
          statisNew.appEventReport({...reportParamsNew, event_data: JSON.stringify([{event: 'finishServer', event_properties: {}, client_time: getPhpNow() }])})
          break;
        case 'CERT':
          statis.cert([{ cert_type: 2, ln_uid: channelServer.ln_uid }]);
          statisNew.appEventReport({...reportParamsNew, event_data: JSON.stringify([{event: 'gameCert', event_properties: {}, client_time: getPhpNow() }])})
          break;
        case 'ENTGAME':
          statis.enterGame([reportParams]);
          statisNew.appEventReport({...reportParamsNew, event_data: JSON.stringify([{event: 'enter_game', event_properties: {}, client_time: getPhpNow() }])})
          break;
        case 'STORAGE':
          this.storageCpData(params);
          break;
        case 'OPENB':
          this.openBrowserOC(params); // 研发链接通过外部浏览器拉起
          break;
        case 'CACHE':
          this.reportClearCache();
          break;
        case 'GAMELOAD':
          this.gameLoadReportEvent(params);
          break;
        case 'CLIENTEVENT':
          statis.clientEvent(params);
          statisNew.appEventReport({...reportParamsNew, event_data: JSON.stringify([{event: params.event, event_properties: {}, client_time: getPhpNow() }])})
          break;
        case 'GET_DEVICE_UUID':
          sendMsg('GET_DEVICE_UUID_SUCCESS', { deviceUUid: getUUids() });
          break;
        case 'AD':
          this.sendIosAdMessage()
          break
        default:
          break;
      }
    });
  },
  showModal() {
    store.commit('SHOW');
  },
  closeModal() {
    store.commit('CLOSE');
  },
  logout() {
    // 清除token
    // thic.clearToken();
    // 重起游戏
    this.reloadGameFrame();
    // 上报时长
    this.online(this.onlineParams);
    sendMsg('LOGOUT_SUCCESS');
  },
  clearToken() {
    cookies.removeItem('ln_h5sdk_user_token');
    cookies.removeItem('ln_h5sdk_guest_token');
  },
  cpChangeAccount() {
    if (mixServer.game_link.indexOf('huanyuantech.com') > -1 || mixServer.game_link.indexOf('xtgame.top') > -1) {
      console.log('切换账号');
      sendMsg('LOGOUT_SUCCESS', {});
      store.commit('SET_CHANGECLICK', true);
    }
    if (mixServer.game_link.indexOf('luckystar001') > -1) {
      const gameFrame = document.querySelector('#gameFrame');
      gameFrame.src = `${mixServer.game_link}?v=${new Date().getTime()}`;
    }
    // 仙梦
    if (mixServer.game_link.indexOf('youyantech.com') > -1) {
      console.log('sdk切换账号');
      store.commit('SET_CHANGECLICK', true);
    }
  },
  reloadGameFrame() {
    const gameFrame = document.querySelector('#gameFrame');
    gameFrame.src = `${gameFrame.src}?v=${new Date().getTime()}`;
    setTimeout(() => {
      store.commit('SHOW', 'PhoneLogin');
    }, 100);
  },
  // 存储研发上报数据
  storageCpData(info) {
    console.log('收到cp上传localstorage数据', info);
    localStorage.setItem('cp_storage', info);
  },
  // 拉起外部浏览器
  openBrowserOC(info) {
    console.log(info, '收到外部浏览器链接');
    let browserUrl = [info];
    try {
      window.webkit.messageHandlers['receiveUrlData'].postMessage({ params: browserUrl });
    } catch (err) {
      console.log('浏览器不支持跳转', err);
    }
  },
  // 发送广告拉起消息给ios客户端
  sendIosAdMessage() {
    try {
      // 穿山甲广告参数传给ios
      window.webkit.messageHandlers['iosAdAction'].postMessage({ params: ['974582145', '荡剑闯天涯-激励视频-标准', 'REWARD_VIDEO'] });
    } catch (error) {
      console.log(error)
    }
  },
  reportClearCache() {
    console.log('h5sdk收到清除缓存响应');
    let statisCacheParams = [{ fu_uid: mixServer.fu_uid, ln_uid: channelServer.ln_uid }];
    statis.clearCacheApi(statisCacheParams);
  },
  gameLoadReportEvent(event) {
    statis.gameLoad(event);
  },
  handlePay(clientParams) {
    const {
      orderId,
      orderName,
      amount,
      total_fee,
      serverId,
      roleName,
      roleId,
      roleLevel,
      ext,
      flag,
      pay_callback
    } = clientParams;
    const params = {
      order_id: orderId || '',
      order_name: orderName || '',
      is_lnpay: 0,
      amount: amount || '',
      total_fee: total_fee || amount || '',
      server: serverId,
      role: roleName,
      roleid: roleId,
      level: roleLevel || '',
      ext: ext || '',
      flag: flag || '',
      pay_callback: pay_callback || '',
      ln_pay_req: 1,
      ver: this.ver || '',
      // 微信支付参数
      weixin_code: this.code || ''
    };
    // 下单成功拉起支付
    mixServer.pay(params).then(data => {
      const { url = '' } = data;
      // console.log(decodeURIComponent(data.hackjs).replace(/\+/g, ' '))
      // 兼容渠道支付宝支付执行js
      // if (data.hackjs) {
      //   setTimeout(() => {
      //     eval(decodeURIComponent(data.hackjs).replace(/\+/g, ' '))
      //   }, 500);
      // }
      // zf_type=1为支付 2为苹果支付
      if (data.zf_type == 1) {
        // 根据url确定是否跳转到浏览器支付
        if (getUrlParams('browser') && getUrlParams('appid') != '63352') {
          let payUrl = [url];
          try {
            window.webkit.messageHandlers['receiveUrlData'].postMessage({ params: payUrl });
          } catch (err) {
            console.log('浏览器不支持跳转', err);
          }
        } else {
          if (platform.isSafari) {
            // safari无法iframe拉起支付，需要通过用户触发，跳转到新页面
            store.commit('SHOW_OPENCONFIRM', url);
          } else {
            pay.show(url);
          }
        }
      } else {
        let payParams = [data.flag, data.order_id, data.zf_type];
        try {
          window.webkit.messageHandlers['payData'].postMessage({ params: payParams });
        } catch (err) {
          console.log('浏览器不支持苹果支付', err);
        }
      }
      // 融合下单成功开始轮训
      if (store.state.isGdtSwitch) {
        this.pollingOrderStatus(data.fu_order_id, amount); 
      }
    });
  },
  handleRoleReport(clientParams) {
    const {
      type,
      roleInfo: { roleId, roleName, roleLevel, sex, serverId, serverName, roleTime }
    } = clientParams;

    const roleParams = {
      type,
      roleid: roleId,
      rolename: roleName,
      level: roleLevel,
      sex: sex || 0,
      server_id: serverId
    };
    this.roleInfoData = roleParams;
    this.roleInfoData.serverName = serverName || '';
    let power = clientParams.power || 0;
    // 角色上报
    // 针对天剑角色升级1s内只上报最后一次
    // 2025.11.1针对九梦大推调整角色等级上报频次
    const limitRoleLevelReportProject = ['https://sdk.sh9130.com', 'https://cls-wc08.huanyuantech.com'];
    const isLimitReport = limitRoleLevelReportProject.some(v => mixServer.game_link.indexOf(v) > -1);
    let delayTime = store.state.role_level_interval;
    // if (mixServer.game_link.indexOf('sdk.sh9130.com') > 0) {
    //   delayTime = 1000;
    // }
    if (!isLimitReport) {
      this.role(roleParams);
    } else {
      if (type == 2) {
        this.roleArray.push(roleParams);
        if (this.roleLevelTimer) clearTimeout(this.roleLevelTimer);
        this.roleLevelTimer = setTimeout(() => {
          // console.log(this.roleArray)
          let currParams = this.roleArray[this.roleArray.length - 1];
          if (this.roleArray.length) {
            this.role(currParams);
          }
        }, delayTime);
      } else {
        this.role(roleParams);
      }
    }
    this.onlineParams = {
      ver: this.ver,
      roleid: roleId,
      server_id: serverId
    };
    let sdkStatisRoleParams = {
      fu_uid: mixServer.fu_uid,
      ln_uid: channelServer.ln_uid,
      ouid: mixServer.ouid,
      role_id: String(roleId),
      role_name: roleName,
      server_id: serverId,
      server_name: serverName,
      level: roleLevel,
      power: power
    };
    // 是否开启红包功能参数
    const rebateAct = {
      ln_uid: channelServer.ln_uid,
      server_no: serverId,
      role_id: roleId,
      level: roleLevel,
      role_name: roleName,
      server_name: serverName
    };

    // 统计sdk角色上报
    let statisRoleParams = [
      {
        time: getPhpNow(),
        fu_uid: mixServer.fu_uid,
        ln_uid: channelServer.ln_uid,
        ouid: mixServer.ouid,
        role_id: String(roleId),
        role_name: roleName,
        server_id: serverId,
        server_name: serverName,
        level: roleLevel,
        power: power
      }
    ];
    // 新统计sdk
    let reportParamsNew = {reporter: 1, ln_uid: parseInt(channelServer.ln_uid), fu_uid: parseInt(mixServer.fu_uid), 
      role_id: String(roleId) || '', role_name: roleName || '', server_id: serverId || '', server_name: serverName || ''}
    statis.roleReport(statisRoleParams, type);

    console.log(type);
    this.roleActionLevel = roleLevel;
    switch (type) {
      case 1:
        // 创角时，顺便上报入服，并走时长上报流程（现在由游戏上报）
        // this.role({ ...roleParams, type: 3 });
        // this.online(this.onlineParams);
        // this.getRebateAct(rebateAct);
        statisNew.appEventReport({...reportParamsNew, event_data:JSON.stringify([{event: 'create_role', event_properties: {role_level: roleLevel}, client_time: getPhpNow() }])});
        if (store.state.isGdtSwitch) {
          try {
            this.isCreateRoleEvent = true;
            // gdt('track', 'CREATE_ROLE')
            window.webkit.messageHandlers['gdtReport'].postMessage({ params: ['CREATE_ROLE', '']});
          } catch (error) {
            console.log(error)
          }
        }
        break;
      case 2:
        this.roleActionLevel = roleLevel;
        statisNew.appEventReport({type: 2, ...reportParamsNew, event_data:JSON.stringify([{event: 'level_up', event_properties: {role_level: roleLevel}, client_time: getPhpNow() }])});
        break;
      case 3:
        // 入服，调在线时长接口，并设置后续上报在线时长
        // 入服，调是否开启红包功能
        // 入服，开启sdk拍脸图弹窗
        console.log('上报类型', type);
        // 每次入服先清除定时器，防止离线登录重复上报
        clearInterval(this.timer);
        this.online(this.onlineParams, sdkStatisRoleParams);
        this.getRebateAct(rebateAct);
        // 主播推广这两个应用不走通知中心
        const notificationExcludeAppids = ['70652', '70660', '71364', '71366', '71532', '71676'];
        if (!notificationExcludeAppids.includes(String(getUrlParams('appid')))) {
          this.notificationConnect(clientParams.roleInfo);
        }
        // 广点通上报完成新手指引,玩家入服15分钟后上报，只上报一次，后续不上报
        try {
          if (this.timerNewUser) clearTimeout(this.timerNewUser);
          if (!localStorage.getItem('gdt_newuser') && store.state.isGdtSwitch) {
           this.timerNewUser = setTimeout(() => {
              // gdt('track', 'TUTORIAL_FINISH')
              window.webkit.messageHandlers['gdtReport'].postMessage({ params: ['TUTORIAL_FINISH', '']});
              localStorage.setItem('gdt_newuser', 1)
            }, 15 * 60 * 1000);
          }
        } catch (error) {
          console.log(error)
        }
        break;
      default:
        break;
    }
    // window.watchcAdCallback(1, 1)
  },
  // 广点通付费上报需要轮询订单支付状态
  pollingOrderStatus(order_id, amount) {
    try {
      const params = {
        order_id
      }
      mixServer.getOrderPayStatus(params).then(data => {
        if (data.pay_status == 0) {
         this.timesOrderStatus++;
         if (this.timesOrderStatus > 9) {
          clearTimeout(this.timerOrderStatus);
          console.log('轮询结束，', this.timesOrderStatus);
         } else {
          this.timerOrderStatus = setTimeout(() => {
            this.pollingOrderStatus(order_id, amount);
            // console.log('继续轮询', this.timesOrderStatus);
          }, 10000);
         }
        } else {
          clearTimeout(this.timerOrderStatus);
          // gdt('track', 'PURCHASE', {amount: amount});
          const purchaseData = JSON.stringify({amount: amount});
          console.log('PURCHASE 上报了', purchaseData)
          window.webkit.messageHandlers['gdtReport'].postMessage({ params: ['PURCHASE', purchaseData]});
        }
      })
    } catch (error) {
      console.log(error)
    }
  },
  // sdk红包打开账户
  openAccount(params) {
    store.commit('SHOW', params.comName);
  },
  setAccount(params) {
    store.commit('SHOW', params.comName);
  },
  // 打开客服窗口
  openKefu(params) {
    store.commit('SET_OPENKEFU', { url: params.kefuUrl, show: true });
  },
  // 在线时长上报(包括首次和后续)
  online(onlineParams, sdkStatisRoleParams) {
    // if (getUrlParams('game_id') == 88) return; // 当游戏id为88时不执行上报时长逻辑
    // 首次上报
    mixServer.online({ ...onlineParams, seconds: 0, type: 1, login_id: mixServer.login_id }).then(data => {
      // 弹出实名登记
      const toCert = data => {
        store.commit('SHOW', {
          name: 'Certification',
          // 在线时长弹出，一定是强制
          params: { ...data, isForceCert: true, is_close: false }
        });
      };

      // 统计sdk时长上报（2min）
      statis.onlineReport([sdkStatisRoleParams]);

      // 需要弹出实名认证
      // if (mixServer.isAntiAddiction == 1) {
      //   if (data.is_allow_online == 0) {
      //     if (store.state.user.cert_type != 1) {
      //       // 如果登录时没有弹出实名认证，则在这里弹出
      //       toCert(data);
      //     }
      //     // 如果不允许在线，强制重启游戏,不后续上报
      //     this.reloadGameFrame();
      //     return;
      //   }
      // }
      this.expire_time = data.expire_time;
      if (mixServer.isAntiAddiction == 1) {
        if (data.is_allow_online == 0) {
          if (data.type == 0) {
            store.commit('CLOSE');
          } else if (data.type == 1) {
            // 强制退出游戏的弹窗不可关闭
            Dialog.alert({
              title: '',
              message: data.cert_msg,
              theme: 'round-button'
            }).then(() => {
              this.reloadGameFrame(); // 退出游戏
            });
            clearInterval(this.timer);
            return;
          } else if (data.type == 2) {
            // 实名认证弹窗不可关闭
            store.commit('SHOW', {
              name: 'Certification',
              params: { cert_msg: data.cert_msg, is_close: false }
            });
            clearInterval(this.timer);
            return;
          }
        } else if (data.is_allow_online == 1) {
          if (data.type == 0) {
            store.commit('CLOSE');
          } else if (data.type == 2) {
            // 弹窗实名认证弹窗，可关闭
            store.commit('SHOW', {
              name: 'Certification',
              params: { cert_msg: data.cert_msg, is_close: true }
            });
          }
        }
      }
      // 后续上报
      const alive = mixServer.initData.alive;
      if (alive) {
        this.timer = setInterval(() => {
          console.log('在线时长上报了');

          // 统计sdk时长上报
          sdkStatisRoleParams.level = this.roleActionLevel;
          statis.onlineReport([sdkStatisRoleParams]);

          mixServer.online({ ...onlineParams, seconds: alive, type: 2, login_id: mixServer.login_id }).then(data => {
            // console.log(data);
            if (mixServer.isAntiAddiction == 1) {
              console.log('进入is_anti_addiction');
              if (data.is_allow_online == 0) {
                console.log('进入is_allow_online');
                if (data.type == 0) {
                  store.commit('CLOSE');
                } else if (data.type == 1) {
                  // 强制退出游戏的弹窗不可关闭
                  console.log('进入type', type);
                  Dialog.alert({
                    title: '',
                    message: data.cert_msg,
                    theme: 'round-button'
                  }).then(() => {
                    this.reloadGameFrame(); // 退出游戏
                  });
                  clearInterval(this.timer);
                } else if (data.type == 2) {
                  // 实名认证弹窗不可关闭
                  store.commit('SHOW', {
                    name: 'Certification',
                    params: { cert_msg: data.cert_msg, is_close: false }
                  });
                  clearInterval(this.timer);
                }
                // 如果不允许在线，强制重启游戏,不后续上报
                // toCert(data);
                // this.reloadGameFrame();
                // clearInterval(this.timer);
              } else if (data.is_allow_online == 1) {
                if (data.type == 0) {
                  // store.commit('CLOSE');
                } else if (data.type == 2) {
                  // 弹窗实名认证弹窗，可关闭
                  store.commit('SHOW', {
                    name: 'Certification',
                    params: { cert_msg: data.cert_msg, is_close: true }
                  });
                }
              } else {
                console.log('都不是');
              }
            }
          });
        }, +mixServer.initData.alive * 1000);
      }
    });
  },
  // 设置共用参数
  setShareParams() {
    this.shareParams = {
      sdkver: 'h5',
      adver: this.adver,
      device: 7,
      idfa: this.idfa,
      idfv: this.idfv,
      imei: this.imei,
      oaid: this.oaid,
      android_id: this.android_id,
      imsi: 'imsi',
      version: '1.0',
      channel_version: '1.0',
      sysname: getSys(),
      screen: getScreen(),
      model: this.model
    };
  },
  // 登录（融合+渠道）
  login(params) {
    // 正常登录
    return channelServer.login(params).then(mixParams => {
      return mixServer.login(mixParams);
    });
  },
  // 手机验证码登录
  loginPhone(params) {
    return channelServer.loginMobile(params).then(mixParams => {
      return mixServer.login(mixParams);
    });
  },
  // 获取token
  getToken() {
    const userToken = cookies.getItem('ln_h5sdk_user_token');
    const guestToken = cookies.getItem('ln_h5sdk_guest_token');
    const token = userToken || guestToken;
    return token;
  },
  // 当检测到有token时自动登录
  autoLogin() {
    store.commit('SET_USER_INFO', {
      name: localStorage.getItem('lnUserAccount'),
      pwd: localStorage.getItem('lnUserPass')
    });
    const userToken = cookies.getItem('ln_h5sdk_user_token');
    const guestToken = cookies.getItem('ln_h5sdk_guest_token');
    let token = userToken;
    // if (store.state.loginType == 2) {
    //   token = guestToken;
    // }
    // console.log(guestToken)
    if (!token) {
      token = guestToken;
    }
    // const token = userToken || guestToken;
    if (token) {
      channelServer.autoLogin({ token });
    }
  },
  // 角色上报（融合+渠道）
  async role(params) {
    await mixServer.role(params);
    // 2025年11.1去掉角色上报，因为后端对这个接口直接返回成功，没做其他处理
    // await channelServer.role(params);
    this.roleArray = [];
  },
  // 是否开启红包
  getRebateAct(params) {
    mixServer.getRebate(params).then(data => {
      console.log(data)
      if (data.open == 1 && !store.state.abroadIp) {
        store.commit('SET_OPEN', true);
        let rebateUrl = data.url.replace('http://', 'https://');
        store.commit(
          'SET_REBATEURL',
          `${rebateUrl}?tk=${data.tk}&access_token=${mixServerConfig.access_token}&sdk=h5&is_vertical_open=${data.is_vertical_open}&stp=${new Date().getTime()}`
        );
        store.commit('SET_VERTICALRB', data.is_vertical_open);
        store.commit('SET_REBATE_ICON', data.float_icon || {full: `${getTopDomain('upres')}/coin/full_7774.gif`, left_side: `${getTopDomain('upres')}/coin/right_side_7774.png`, right_side: `${getTopDomain('upres')}/coin/left_side_7774.png`});
        // store.commit('SET_REBATE_ICON', data.float_icon);
        if (data.auto_popup == 1) {
          store.commit('SET_AUTOOPENREB', true);
        }
      } else {
        store.commit('SET_OPEN', false);
      }
    });
  },

  // 【通知中心】长连接上传用户信息
  notificationConnect(roleInfo) {
    const { roleId, serverId, roleLevel } = roleInfo;

    notificationPostmessager.emit({
      action: 'NOTIFICATION_CONNECT',
      data: {
        mixServerBaseUrl,
        access_token: mixServerConfig.access_token,
        appid: this.appid,
        ln_uid: channelServer.ln_uid,
        role_id: roleId,
        server_no: serverId,
        level: roleLevel
      }
    });
  },

  // ipv6接口
  getIpV6() {
    try {
      let currParams = {
        uuid: getUUids() || '',
        time: getPhpNow(),
        app: this.appid,
        package_campaign: this.ver
      };
      let paramStr = `uuid=${getUUids()}&time=${getPhpNow()}&app=${this.appid}&package_campaign=${
        this.ver
      }&sign=${getSignStatis('ipv6&&&D##!2DD', { ...currParams })}`;
      getIpv6Api(paramStr).then(data => {
        console.log(data);
      });
    } catch (error) {
      console.log(error);
    }
  }
};

// 发送信息给游戏窗口
export const sendMsg = (msg = {}, params = {}) => {
  const gameFrame = document.querySelector('#gameFrame');
  const gameWin = gameFrame.contentWindow;
  // 传进来的params为对象，需转换为原本SDK的参数形式，即[param1,param2,...]这种
  console.log(params);
  const payload = { action: msg, params: Object.values(params) };
  gameWin.postMessage(payload, '*');
};

// 挂载全局ios回调广告状态及上报统计sdk
window.watchcAdCallback = function(event, status) {
  try {
    const statisData = {
      status: status,
      fu_uid: mixServer.fu_uid,
      ln_uid: channelServer.ln_uid,
      ad_unit_id: '974582145',
      ad_unit_name: '荡剑闯天涯-激励视频-标准',
      role_id: server.roleInfoData.roleid,
      role_name: server.roleInfoData.rolename,
      server_id: server.roleInfoData.server_id,
      server_name: server.roleInfoData.serverName
    }
    if (event == 1) {
      // 完播
      if (status == 1 && status == 0) {
        sendMsg('AD_SUCCESS', {ad: false});
      }
      statis.adReportWatchAction(statisData);
    }
    if (event == 2) {
      // 拉取
      statis.adReportReqAction(statisData);
    }
    if (event == 3) {
      // 曝光
      statis.adReportExposureAction(statisData);
    }
  } catch (error) {
    console.log(error)
  }
}
// 完成广告播放客户端回调
window.adRewardCompletion = function(adId, adName, adType) {
   // 观看完广告回调广告状态给研发
   sendMsg('AD_SUCCESS', {ad: true});
}

export default server;
